import invoice from '@/api/invoice-confirm'
import productAPI from '@/api/product'

import { baseState, baseMutations } from '@/store/mixins'

export const state = {
  ...baseState
}

export const getters = {}

export const mutations = {
  ...baseMutations
}
export const actions = {
  fetch(context, attrubutes = {}) {
    let params = Object.assign(
      {
        page: context.state.pagination.page,
        perPage: context.state.pagination.perPage,
        filter: {
          search: context.state.search
        }
      },
      attrubutes
    )
    return invoice.get({ params }).then(response => {
      context.commit('RECEIVE_RESOURCES', response)
      return Promise.resolve(response)
    })
  },
  store(context, data) {
    return invoice.store(data)
  },
  scanInvoice(context, data) {
    return invoice.scanInvoice(data)
  },
  async getProduct(context) {
    let response = await productAPI.get({
      params: {
        page: -1,
        filter: {
          location_base: true,
          has_provided_sale_code: true,
          price_set: true,
          // category_id: [1]
        },
        fields: {
          setup_inventory_products: 'product_id,product_name_en,barcode'
        },
        headers: {
          'X-PERMISSION-ALLOW-CODE': context.rootGetters.permissionAllowCode
        }
      }
    })
    return Promise.resolve(response)
  },
  previewPdf(context, id) {
    return invoice.printPDF(id)
  }
}
